import { RootState } from '@store/store';



export const selectLanguage = (state: RootState) => state.global.language;
export const selectAppMode = (state: RootState) => state.global.appMode;